import { useState } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";
import { FormikProps } from "formik";

function SubmitInitialApplicationComponent({ disabled }: any) {
  const api = useApiClient("SubmitInitialApplication");
  const [errors, setErrors] = useState<string[]>([]);
  function displayErrors(error: any) {
    if (error.response.data?.validationResults?.length > 0) {
      setErrors(error.response.data.validationResults.map((r: any) => r.errorMessage));
      error.response = null;
    }
  }

  const { id } = useApplicationContext();

  function getInitialValues(initialData: any, formik: FormikProps<any>) {
    formik.setFieldValue("rowVersion", initialData.rowVersion);
  }

  return (
    <BaseApplicationComponent
      formBody={{
        fields: [
          {
            type: "field",
            fieldType: "advisory",
            key: "adv",
            props: {
              type: "warning",
              Body: () => (
                <div>
                  <p>You can submit this application when you have completed all 10 sections of the application form.</p>
                  <br />
                  <p>
                    When you click submit, the portal will check all sections to make sure that all fields have been completed correctly. The portal
                    will not allow you to submit the application if it contains any errors and you will need to fix any errors before attempting to
                    submit again.
                  </p>
                  <br />
                  <p>
                    Once the application has been submitted, our support team will review the application. Within 4 business days, you will either
                    receive an email confirming that the application is complete, or you will receive a request for additional information.
                  </p>
                  <br />
                  <p>
                    Once all information is present, the application will progress to our assessment team. This will take place within 10 business
                    days. When the assessment is complete, you’ll receive an email providing you with the outcome. In some instances, the assessor may
                    request more information, in order to complete the assessment. You will receive an email if this is the case.
                  </p>
                  <br />
                  <p>
                    <strong>
                      You must provide the child’s parent/guardian/carer with a copy of the application, which you can access via the Print
                      Application - Print Parent Copy button in the top right of the application.
                    </strong>
                  </p>
                  <br />
                  <p>
                    If you have any further questions about the KIS Program please refer to the Department of Education website or for submission
                    questions contact us directly via email support@kisapplications.com.au, or on 1300 564 149.
                  </p>
                </div>
              ),
            },
          },
          {
            type: "component",
            body: () =>
              errors.length > 0 && (
                <div className="error">
                  <p>Please refer to:</p>
                  <ul>
                    {errors.map((e, i) => (
                      <li key={i}>Section {e} for errors</li>
                    ))}
                  </ul>
                </div>
              ),
          },
        ],
        type: "formGroup",
      }}
      headerLabel="Submit KIS Application for Assessment"
      editPath="submitapplication"
      apiClient={api}
      disabled={disabled}
      id={id}
      showInternalNotes={false}
      submitBtnTitle="Submit Application"
      saveErrorCB={displayErrors}
      submitPath={"/home"}
      showNoValidateBtn={false}
      getInitialValues={getInitialValues}
    />
  );
}

export default SubmitInitialApplicationComponent;
